import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

export default function dashCard({title, text, chartComponent}) {
  return (
    <Card style={{ width: '18rem', height: '25rem' }} className='d-flex flex-column'>
      {chartComponent && <div className='flex-fill'>{chartComponent}</div>}
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        {/* <Card.Text>
          {text}
        </Card.Text> */}
        <Button variant="info">상세정보</Button>
      </Card.Body>
    </Card>
  );
}